import axios from 'axios';

import { API_URL } from '../utils';

export const baseURL = API_URL;

/**
 * @param {import('axios').AxiosInstance} axios
 * @param {import('axios').AxiosRequestConfig} config
 */
export const baseAxios = (axios, config) => {
  config = { baseURL, ...config };
  return axios(config).then((res) => res.data);
};

/**
 * @param {any} err
 */
export const handleError = (err) => {
  if (axios.isAxiosError(err)) {
    console.log(err.message);
  } else {
    console.log(err);
  }
  throw err;
};
